import { createSSRApp } from 'vue'
import App from './App.vue'
import store from './store'
import { prototypeInterceptor, routerBeforeEachConfig } from './interceptors'
import 'virtual:uno.css'
import '@/style/index.scss'
import { loadingClick } from './directives'
import './directives/common/loadingClickStyle.css'
import { showModal } from './utils'
import { useAppContext } from './hooks/appContext'

window.addEventListener('vite:preloadError', async (event) => {
  console.log('检测到有新版本', event)
  // await showModal('检测到有新版本', {
  //   confirmText: '立即更新',
  // })
  window.location.reload()
})

export function createApp() {
  const app = createSSRApp(App)
  useAppContext.setAppContext(app._context)
  app.use(store)
  // app.use(routeInterceptor)
  app.use(prototypeInterceptor)
  app.directive('loadingClick', loadingClick)

  setTimeout(() => {
    routerBeforeEachConfig((app as any).router)
  }, 0)

  return {
    app,
  }
}
